<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>退换货列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.reject_id"
                    placeholder="退换货单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.work_id"
                    placeholder="工单id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.dbid"
                    placeholder="打标id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.woid"
                    placeholder="代采订单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="city">
                  <el-select
                    v-model="form.city"
                    multiple
                    filterable
                    placeholder="城市"
                    @change="setMarket"
                  >
                    <el-option
                      v-for="item in searchOptions.city"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="market_id">
                  <el-select
                    v-model="form.market_id"
                    multiple
                    filterable
                    placeholder="子市场"
                  >
                    <el-option
                      v-for="item in searchOptions.child_market"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.pgname"
                    placeholder="代采组"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.reject_status" placeholder="状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="处理中" value="2"></el-option>
                    <el-option label="已处理完成" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.sku"
                    placeholder="sku"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.stock_out_admin"
                    placeholder="出库人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="searchOptions"
                    v-model="form.blp_type"
                    placeholder="不良品类型"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.blp_type"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="searchOptions"
                    v-model="form.supply_deal_way"
                    placeholder="处理方式"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.supply_deal_way"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pre_label"
                    placeholder="预处理方式"
                    multiple
                  >
                    <el-option
                      v-for="item in pre_label"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="searchOptions"
                    v-model="form.referer_type"
                    placeholder="来源"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.referer_type"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.dgid"
                    filterable
                    placeholder="次品组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.dg_group"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.dpc_id"
                    filterable
                    placeholder="退换货负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.option_dgm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="生成时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="reject_id"
              label="退换货单号"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sku"
              label="sku"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="reject_detail_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="woid"
              label="代采单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="referer_type"
              label="来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="blp_type"
              label="不良品类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="退换货欠货生成时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="reject_detail_supply_deal_way"
              label="处理方式"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="deal_admin"
              label="处理人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="work_id"
              label="工单id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="service_order_handle_type"
              label="工单处理方式"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="fix_by_stagnation_point_str"
              label="是否驻点修复"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="service_order_handle_status"
              label="工单状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="最后操作时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      searchOptions: null,
      form: {
        create_time: this.$excalibur.getDateTimeOnHours(-3, 6),
        status: "",
        referer: 1,
      },
      loading: false, // 加载动画是否显示
      url: "/erp/reject/rejectList",
      status: "",
      curPage: 1,
      loading: false,
      tableLoading: false,
      filterFold: false,
      pre_label: [
        {
          label: "预抵扣",
          value: "1",
        },
        {
          label: "预呆账",
          value: "2",
        },
        {
          label: "预退款",
          value: "3",
        },
        {
          label: "预坏账",
          value: "4",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  // created() {
  //   this.fetchData();
  // },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    handleClick(row) {},
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.filteredForm.get_search_options = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.searchOptions = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.filteredForm.get_search_options = 0;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    setMarket(value) {
      this.$http
        .post(this.url, { city: value, get_search_options: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
          }
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/reject/RejectList.vue